/* eslint-disable react-hooks/exhaustive-deps,jsx-a11y/anchor-is-valid */
import {default as React, useEffect, useState} from 'react';
import "../assets/css/style/whatschat-style8.css";
import {default as linkGenerator} from "../helper/waLinksGenerator";
import p01 from "../assets/img/profile_01.jpg";
import p02 from "../assets/img/profile_02.jpg";
import p03 from "../assets/img/profile_03.jpg";
import p04 from "../assets/img/profile_04.jpg";
import p05 from "../assets/img/profile_05.jpg";
import p06 from "../assets/img/profile_06.jpg";
import p07 from "../assets/img/profile_08.jpg";
import p08 from "../assets/img/profile_09.jpg";
import p09 from "../assets/img/profile_10.jpg";

const ChatLinks = (index, title, subTitle, phone, keyword, img, onClickEvent = null, hide = false) => {
    const onClick = () => {
        const link = linkGenerator(phone, keyword);
        if("function"===typeof onClickEvent) onClickEvent(phone,keyword);
        window.open(link);
    };

    return (
        <li key={index}>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a className={`wc-list wc-list-sm scale-transition ${hide ? 'scale-out' : ''}`} onClick={onClick}>
                <div className="wc-user-info">
                    <strong>{title}</strong>
                    {subTitle && <p>{subTitle}</p>}
                </div>
                <div className="wc-img-cont">
                    <img className="wc-user-img" src={img} alt=""/>
                </div>
            </a>
        </li>
    )
};

const Chat = ({data = [], onChangeResize = null, onClickEvent=null}) => {

    const [isOpen, setIsOpen] = useState(true);
    const [buttonSize, setButtonSize] = useState({height:0,width:0});
    const [chatSize, setChatSize] = useState({height:0,width:0});

    useEffect(() => {
        const buttonHtml = document.getElementById('wcBtn');
        const buttonClientSize = {height:buttonHtml.offsetHeight + 30,width:buttonHtml.offsetWidth + 30};
        const buttonClientHeight = buttonClientSize.height;
        const widgetClientSize = [...document.getElementsByClassName('wc-list-sm')].reduce((acc, item) => {
            return acc + item.offsetHeight + 10;
        }, buttonClientHeight);
        setButtonSize(buttonClientSize);
        setChatSize({height:widgetClientSize,width:265});
        if(typeof onChangeResize === "function") onChangeResize(buttonClientSize);
    }, []);

    const onClick = () => {
        const buttonState = !isOpen;
        if (typeof onChangeResize === "function") {
            onChangeResize(buttonState?buttonSize:chatSize);
        }
        setIsOpen(buttonState);
    };

    return (
        <div className="wc-style8">
            <div className="wc-panel">
                <a className="wc-button" id="wcBtn" onClick={onClick}>
                    <i className="fa fa-whatsapp" aria-hidden="true"></i>
                </a>
                <ul id="wcMenu">
                    {Array.isArray(data) && data.filter((x,i)=>i<9).map(({title, subTitle, phone, keyword}, index) => {
                        let img = null;
                        switch (index + 1) {
                            case 1:
                                img = p01;
                                break;
                            case 2:
                                img = p02;
                                break;
                            case 3:
                                img = p03;
                                break;
                            case 4:
                                img = p04;
                                break;
                            case 5:
                                img = p05;
                                break;
                            case 6:
                                img = p06;
                                break;
                            case 7:
                                img = p07;
                                break;
                            case 8:
                                img = p08;
                                break;
                            default:
                                img = p09;
                                break;
                        }
                        return ChatLinks(index, title, subTitle, phone, keyword, img, onClickEvent, isOpen);
                    })}
                </ul>
            </div>
        </div>
    )
};

export default Chat;